import { useMemo } from "react";
import Text from "../../../Text/Text";

const MainInfoCardTitle = (
    {
        text,
        style
    }:{
        text: string;
        style?: "normal" | "disabled" | "highlight";
    }
) => {

    const m_color = useMemo(() => {
        switch(style){
            case "disabled":
                return "gray3";
            case "highlight":
                return "red_gray";
            default:
                return "dark";
        }
    }, [style])

    return(
        <Text
            preset={"content_title"}
            color={m_color}
            bold={true}
        >                                
            {text}
        </Text>
    )
}

export default MainInfoCardTitle;